import { RESOURCE_DELIVERY_TYPES } from '../constants/resourceDeliveryTypes';
const getIsMainOrVendorScriptLoadedThroughCache = (resourceEntry) => {
    return (resourceEntry.initiatorType === 'link' &&
        (resourceEntry.name.includes('main') ||
            resourceEntry.name.includes('vendor')) &&
        resourceEntry.deliveryType === 'cache');
};
export const getResourceDeliveryType = () => {
    if (typeof (performance === null || performance === void 0 ? void 0 : performance.getEntriesByType) === 'function') {
        const resourceEntries = performance.getEntriesByType('resource');
        const cachedScripts = resourceEntries.find((entry) => {
            const isMainOrVendorScriptLoadedThroughCache = getIsMainOrVendorScriptLoadedThroughCache(entry);
            return isMainOrVendorScriptLoadedThroughCache;
        });
        if (cachedScripts) {
            return RESOURCE_DELIVERY_TYPES.CACHED;
        }
    }
    return RESOURCE_DELIVERY_TYPES.UNCACHED;
};
//# sourceMappingURL=getResourceDeliveryType.js.map